import { render, staticRenderFns } from "./SFaddi.vue?vue&type=template&id=0195a4fc&"
import script from "./SFaddi.vue?vue&type=script&setup=true&lang=js&"
export * from "./SFaddi.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SFmain.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports